var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverAction1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 13C16.8824 13 21.3594 7 21.3594 7C21.3594 7 16.8824 1 11.3594 1C5.83638 1 1.35938 7 1.35938 7C1.35938 7 5.83638 13 11.3594 13Z",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3594 9.5C12.0224 9.5 12.6583 9.23661 13.1271 8.76777C13.596 8.29893 13.8594 7.66304 13.8594 7C13.8594 6.33696 13.596 5.70107 13.1271 5.23223C12.6583 4.76339 12.0224 4.5 11.3594 4.5C10.6963 4.5 10.0604 4.76339 9.59161 5.23223C9.12277 5.70107 8.85938 6.33696 8.85938 7C8.85938 7.66304 9.12277 8.29893 9.59161 8.76777C10.0604 9.23661 10.6963 9.5 11.3594 9.5Z",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverAction1);
export default __webpack_public_path__ + "static/media/Driver_action1.261df307ff4781f62ff7360c656cc390.svg";
export { ForwardRef as ReactComponent };